
import { useState } from 'react';
import { GamePlan } from '@/types/gamePlanner';
import { SortOption } from '../components/SortControls';

export function usePlanSorting() {
  const [sortBy, setSortBy] = useState<SortOption>('alphabetical');
  const [searchQuery, setSearchQuery] = useState<string>('');

  const getSortedPlans = (plansToSort: GamePlan[]) => {
    // First filter by search query if present
    let filteredPlans = plansToSort;
    
    if (searchQuery.trim()) {
      const query = searchQuery.toLowerCase();
      filteredPlans = plansToSort.filter(plan => 
        plan.name.toLowerCase().includes(query) || 
        (plan.description && plan.description.toLowerCase().includes(query))
      );
    }
    
    // Then sort the filtered plans
    return [...filteredPlans].sort((a, b) => {
      if (sortBy === 'alphabetical') {
        return a.name.localeCompare(b.name);
      } else if (sortBy === 'newest') {
        return new Date(b.created_at || '').getTime() - new Date(a.created_at || '').getTime();
      } else if (sortBy === 'recent') {
        return new Date(b.updated_at || '').getTime() - new Date(a.updated_at || '').getTime();
      }
      return 0;
    });
  };

  return {
    sortBy,
    setSortBy,
    searchQuery,
    setSearchQuery,
    getSortedPlans
  };
}
